import { AuthService } from "./../../shared/models/auth.service";
import { IKeyValueInterface } from "./../../shared/config";
import { TranslateService } from "./../../shared/translate/translate.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { WeGoConfig, IAPIResponse } from "../../shared/config";
import { Observable } from "rxjs/Observable";
import { ForgotPasswordModel } from "../models/forgotpassword.model";
import { ForgotPasswordService } from "../models/forgotpassword.service";

@Component({
  selector: "wego-forgotpassword",
  template: require('../views/forgotpassword.component.html'),
  providers: [ForgotPasswordService]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  errorMessage: string;
  model: ForgotPasswordModel;
  message: string;
  errorModel: IKeyValueInterface[];

  constructor(
    private forgotpasswordService: ForgotPasswordService,
    private translate: TranslateService,
    private authService: AuthService
  ) {}
  ngOnInit() {
    this.translate.setDetectedLang();
    this.model = new ForgotPasswordModel();
  }

  onSubmit(forms: any) {
    this.SubmitUser();
  }

  public SubmitUser() {
    this.isLoading = true;
    this.forgotpasswordService.SubmitUser(this.model).subscribe(
      res => {
        if (res.data) {
          this.message =
            "We have sent a password reset link to your registered email address.";
          this.isLoading = false;
          this.model = new ForgotPasswordModel();
        } else if (res.data == "") {
          this.message = "Please Enter User Name";
          this.isLoading = false;
        } else {
          this.message = res.error;
          this.isLoading = false;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/forgotpassword/components/forgotpassword.component.ts